export default __webpack_public_path__ + "static/media/ic_github.364350ac.svg";